// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2351":"78f8af2e","6909":"78f8af2e"}[chunkId] + ".chunk.css";
};